<div class="main">
  <section>
    <h1>{{ title }}</h1>
    <p>{{ configuration }}</p>
  </section>
</div>
